import React from 'react';
import { Box, Text, TextLink } from '@hawkins/components';

export const CalculatorDescription = () => {
  return (
    <Box>
      <Text>
        By inputting your lens squeeze factor, intended aspect ratio and safety
        crop, this calculator will help you determine the minimum resolution
        necessary to meet the Netflix UHD requirement..
      </Text>
      <br />
      <Text>
        For more information on framing and working with different resolution,
        please visit the{' '}
        <TextLink
          href="https://partnerhelp.netflixstudios.com/hc/en-us/articles/4465014482323"
          target="_blank"
        >
          Netflix Partner Help Center
        </TextLink>
      </Text>
    </Box>
  );
};
